import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from '@gc-npm/utils.enums.colors';
import { TEXT_COLOR } from '@gc-npm/components.text';
import CustomLink from '@gc-npm/components.custom-link';
import Glyph from '@gc-npm/components.icon-glyph';

const InputNumber = ({
  value,
  min,
  max,
  step,
  disabled,
  readOnly,
  taggingInfo,
  onChange: onChangeProp,
  blockMinusLines,
  blockPlusLines,
}) => {
  const InputNumberTaggingInfo = {
    componentName: 'InputNumber',
    componentContent: '',
    componentProduct: '',
    componentVariation: '',
    eventType: 'click',
    ...taggingInfo,
  }

  const handleChange = (newValue) => {
    if (newValue >= min && newValue <= max) {
      if (!disabled && onChangeProp) {
        onChangeProp(newValue);
      }
    }
  };

  return (
    <fieldset className="InputNumber">
      <div className="InputNumber--sub">
        <CustomLink
          disabled={value === min || blockMinusLines}
          taggingInfo={{
            ...InputNumberTaggingInfo,
            componentContent: 'quitar',
          }}
          onClick={() => {
            handleChange(value - 1);
          }}
        >
          <Glyph
            id="operator-substract-m"
            height={16}
            width={16}
            color={(value === min || blockMinusLines) ? TEXT_COLOR.GREY3 : TEXT_COLOR.MOVISTAR_BLUE}
          />
        </CustomLink>
      </div>
      <input
        type="number"
        className="InputNumber--value"
        onChange={handleChange}
        value={value}
        max={max}
        min={min}
        step={step}
        disabled={disabled}
        readOnly={readOnly}
      />
      <div className="InputNumber--add">
        <CustomLink
          disabled={value === max || blockPlusLines}
          taggingInfo={{
            ...InputNumberTaggingInfo,
            componentContent: 'añadir',
            eventType: 'click',
          }}
          onClick={() => {
            handleChange(value + 1);
          }}
        >
          <Glyph
            id="operator-add-m"
            height={16}
            width={16}
            color={(value === max || blockPlusLines) ? TEXT_COLOR.GREY3 : TEXT_COLOR.MOVISTAR_BLUE}
          />
        </CustomLink>
      </div>
      <style jsx>
        {`
        .InputNumber {
          position: relative;
          display: flex;
          align-items: center;
          border: 1px solid ${COLORS.grey300};
          border-radius: 0.25rem;
          padding: 0 1rem;

          input[type='number'] {
            appearance: textfield;
          }
          input[type='number']::-webkit-inner-spin-button,
          input[type='number']::-webkit-outer-spin-button {
            -webkit-appearance: none;
          }

          &--value {
            font-size: 1.25rem;
            color: ${COLORS.grey400};
            text-align: center;
            outline-color: ${COLORS.movistarBlue};
          }
        }

      `}
      </style>
    </fieldset>
  );
};

InputNumber.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  taggingInfo: PropTypes.object,
};

InputNumber.defaultProps = {
  value: 0,
  min: 0,
  max: 99,
  step: 1,
  disabled: false,
  readOnly: true,
  onChange: () => {},
  taggingInfo: {},
};

export default InputNumber;
